import { ICardList } from '@nocode/types';
import { get, isEmpty } from 'lodash';
import queryString from 'query-string';
import React from 'react';
import {
  FlatList,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import EmptyList from '../EmptyList';
import Loading from '../Loading';
import { processStyles } from '../util.style';
import CardItem from './Card';
import { getItemList } from './func';

const CardList = (attrs: ICardList) => {
  const { page, totalPage, onLoadMore, initializeList, isLoadMore } = attrs;

  const { finalStyle } = processStyles({
    style: attrs.style,
    ...attrs,
  });

  const data = getItemList(attrs);
  const tableId = get(attrs, 'attributes.items.source.tableId');
  const isShowFooter = totalPage > page;
  const search = !isEmpty(window)
    ? queryString.parse(window?.location?.search)
    : {};
  const target = search?.target;

  const emptyList = (target && !tableId) || (!tableId && Platform.OS !== 'web');

  if (emptyList)
    return (
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          zIndex: attrs.zIndex,
        }}
      >
        <EmptyList attributes={attrs} />
      </View>
    );

  if (initializeList) {
    return <Loading />;
  }

  const ListFooterComponent = () => {
    return (
      <TouchableOpacity
        onPress={() => {
          if (isShowFooter) {
            onLoadMore();
          }
        }}
      >
        {isLoadMore ? (
          <Loading />
        ) : (
          <Text
            style={{
              fontSize: 14,
              textDecorationLine: 'underline',
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            もっとロード
          </Text>
        )}
      </TouchableOpacity>
    );
  };

  // Apply finalStyle to container and column wrapper
  const styles = StyleSheet.create({
    container: {
      backgroundColor:
        finalStyle?.backgroundColor || attrs.attributes?.backgroundColor,
      opacity: finalStyle?.opacity || attrs.attributes?.opacity || 1,
    },
  });

  return (
    <View style={styles.container}>
      <FlatList
        data={data}
        renderItem={({ item, index }) => (
          <CardItem
            index={index}
            item={item}
            attrs={attrs}
            onPress={attrs.onPress}
            isWeb={attrs.isWeb}
            finalStyle={finalStyle}
          />
        )}
        key={attrs.attributes.columnCount}
        numColumns={attrs.attributes.columnCount || 2}
        {...(attrs.attributes.columnCount > 1
          ? {
              columnWrapperStyle: {
                display: 'flex',
                justifyContent: 'center',
              },
            }
          : {})}
      />

      {isShowFooter ? <ListFooterComponent /> : <React.Fragment />}
    </View>
  );
};

export default CardList;
